export default __webpack_public_path__ + "static/media/ru.089ae0e4.jpg";